// extracted by mini-css-extract-plugin
module.exports = {"addToCartControl":"Hv","giftCard":"Iv","btnContainer":"Jv","cartButton":"Kv","disabled":"Lv","stockMessage":"Mv"};